var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social-links__container"},_vm._l((_vm.socialLinks),function(socialLink){return _c('social-link-item',_vm._b({key:socialLink.url},'social-link-item',socialLink,false))}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }